import React, { useEffect, useState } from "react";
import MainContent from "../../layouts/maincontent/MainContent";
import imgPayment from "../../assets/img/paymentCart.png";
import InputElement from "../../shared/form/InputElement";
import ahlyBank from "../../assets/img/nbBank.png";
import alexBank from "../../assets/img/alexBank.png";
import masrBank from "../../assets/img/misrBank.png";
import carioBank from "../../assets/img/cairoBank.png";
import aubBank from "../../assets/img/ahliUnitedBank.png";
import abkBank from "../../assets/img/abkBank.png";
import egBank from "../../assets/img/egBank.png";
import fabMisrBank from "../../assets/img/fabMisrBank.png";
import faselBank from "../../assets/img/faselBank.png";
import nbgBank from "../../assets/img/nbgBank.png";
import albarkaBank from "../../assets/img/albarkaBank.png";
import arabBank from "../../assets/img/arabBank.png";
import nibBank from "../../assets/img/nibBank.png";
import nbdBank from "../../assets/img/nbdBank.png";
import saibBank from "../../assets/img/saibBank.png";
import egyptPostBank from "../../assets/img/egyptPostBank.png";
import ealbBank from "../../assets/img/ealbBank.png";
import housingBank from "../../assets/img/housingBank.png";
import abcBank from "../../assets/img/abcBank.png";
import arabInvesBank from "../../assets/img/arabInvesBank.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getPaymentData } from "../../adapters/apis/lookups/lookups";
import { useNavigate, useParams } from "react-router-dom";
import {
  validateNotDigitSpicalCharacters,
  validatePostiveFloat,
} from "../../helpers/Validation";
import { store_payment } from "../../adapters/apis/onlinePayment/save";
import { get } from "../../adapters/xhr/api";

function PayOnline() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false,
    // pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [isChecked, setIsChecked] = useState(false);
  const [payerName, setPayerName] = useState("");
  const [amount, setAmount] = useState("");
  const [errorPayerName, setErrorPayerName] = useState("");
  const [errorAmount, setErrorAmount] = useState("");
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified =
         response?.data?.phone_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  function handleChangeAmount(parentCompenent, compenent, key, value) {
    // minimum value is zero and maximum value is total tax
    if (
      (!isChecked && validatePostiveFloat(value) && value > 0) ||
      value === ""
    ) {
      setAmount(value);
      if (parseInt(value) === 0 || parseInt(value) > data.payment) {
        setErrorAmount(
          "يجب ان يكون المبلغ اكثر من جنية واقل من المبلغ الضريبي.",
        );
      } else {
        setErrorAmount("");
      }
    }
  }
  function handleChangeName(parentCompenent, compenent, key, value) {
    if (validateNotDigitSpicalCharacters(value)) {
      setPayerName(value);
      setErrorPayerName("");
    }
  }
  function handleChangeCheckBox() {
    //should be also greater than 0
    if (!isChecked) {
      setAmount(data.payment);
      if (parseInt(data.payment) <= 0) {
        setErrorAmount(
          "يجب ان يكون المبلغ اكثر من جنية واقل من المبلغ الضريبي.",
        );
      } else {
        setErrorAmount("");
      }
    } else {
      setAmount("");
      setErrorAmount("");
    }
    setIsChecked((prev) => !prev);
  }
  function handleSubmit() {
    setIsLoading(true); // Set loading state to true immediately when the button is clicked
    if (amount === "") {
      setErrorAmount("رجاءا ادخال المبلغ المراد دفعه");
      setIsLoading(false); // Reset loading state if validation fails
    }
    if (payerName === "") {
      setErrorPayerName("رجاءا ادخال اسم المسدد ");
      setIsLoading(false); // Reset loading state if validation fails
    }
    if (amount !== "" && payerName !== "") {
      const postData = new FormData();
      postData.append("payment_amount", amount);
      postData.append("payer_name", payerName);
      postData.append("payment_id", id);
      postData.append("amount_before_paid", data.payment);
      store_payment(postData)
        .then((res) => {
          localStorage.setItem(
            "onlinePaymentId",
            res.data.data.onlinePaymentId,
          );
          // this for debug
          /*
          localStorage.setItem(
              "SenderID",
              res.data.data.SenderID
          );

          localStorage.setItem(
              "RandomSecret",
              res.data.data.RandomSecret
          );

          localStorage.setItem(
            "RequestObject",
              res.data.data.RequestObject
          );
          
          localStorage.setItem(
            "HashedRequestObject",
              res.data.data.HashedRequestObject
              );
              */
          document.initiationForm.action = res.data.data.payment_gateway_url;
          document.getElementById("SenderID").value = res.data.data.SenderID;
          document.getElementById("RandomSecret").value =
            res.data.data.RandomSecret;
          document.getElementById("RequestObject").value =
            res.data.data.RequestObject;
          document.getElementById("HashedRequestObject").value =
            res.data.data.HashedRequestObject;
          document.getElementById("initiationForm").submit();
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false); // Reset loading state if an error occurs
        });
    }
  }

  useEffect(() => {
    setIsLoading(false);
    getPaymentData(id)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 404) {
          navigate("/not-found");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <MainContent>
      <div className="pay-onilne">
        <div className="container mt-5 pb-5">
          <div className="row">
            <form
              method="POST"
              id="initiationForm"
              name="initiationForm"
              action=""
            >
              <input type="hidden" name="SenderID" id="SenderID" value="" />
              <input
                type="hidden"
                name="RandomSecret"
                id="RandomSecret"
                value=""
              />
              <input
                type="hidden"
                name="RequestObject"
                id="RequestObject"
                value=""
              />
              <input
                type="hidden"
                name="HashedRequestObject"
                id="HashedRequestObject"
                value=""
              />
            </form>
          </div>
          <div className="row">
            <div className="col-lg-4 d-lg-block d-none">
              <img
                src={imgPayment}
                alt="pay online"
                className="pay-online__man-cart"
              />
            </div>
            <div className="col-lg-8">
              <div className="pay-online__statusAccount d-flex justify-content-around align-items-center">
                <div className="pay-online__accountCode">
                  <h4 className="title">كود حساب الوحدة</h4>
                  <h3 className="text">{data.acc_key}</h3>
                </div>
                <div className="pay-online__accountCode">
                  <h4 className="title">المبلغ الضريبى</h4>
                  <h3 className="text">{data.payment} جنية مصرى</h3>
                </div>
              </div>
              <div className="pay-online__payNow mt-3 flex-lg-row flex-column d-flex justify-content-between">
                <div className="enteredForm">
                  {/* <div className="text-center d-lg-none d-block mb-4">
                    <img className="w-lg-75 w-50 img-efinance" src={ logo_efinance } alt='logo efinance' />
                  </div> */}
                  <p className="title">
                    يمكنك السداد المبلغ المستحق من خلال الدفع الإلكترونى
                  </p>
                  <form>
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="payer_name"
                      name="payer_name"
                      labelClassName={`required form-label`}
                      labelText="أسم المسدد"
                      inputType="text"
                      inputClassName={`form-control`}
                      inputID="payer_name"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeName}
                      value={payerName}
                      pText={errorPayerName}
                    />
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="amount"
                      name="amount"
                      labelClassName={`required form-label`}
                      labelText="المبلغ المراد دفعة"
                      inputType="text"
                      inputClassName={`form-control`}
                      inputID="amount"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      onChange={handleChangeAmount}
                      min={0}
                      value={amount}
                      pText={errorAmount}
                    />
                    <label
                      htmlFor="full_deserved_amount"
                      className={`list-group-item border-0 mb-lg-0 mb-3`}
                    >
                      <input
                        type="checkbox"
                        className={`form-check-input ms-3`}
                        checked={isChecked}
                        name="full_deserved_amount"
                        id="full_deserved_amount_checkbox"
                        onChange={handleChangeCheckBox}
                      />
                      تسديد المبلغ المستحق بالكامل
                    </label>
                    <p className="text d-lg-block d-none">
                      أو يمكنك السداد في إحدى البنوك التالية بأستخدام كود الوحدة
                    </p>
                  </form>
                </div>
                <div className="logo_btnPay d-flex flex-column-reverse flex-nowrap align-items-lg-end align-items-start justify-content-between">
                  {/* <img className="w-75 d-lg-block d-none img-efinance" src={ logo_efinance } alt='logo efinance' /> */}
                  <button
                    className="btn-payNow"
                    onClick={handleSubmit}
                    disabled={
                      errorAmount !== "" ||
                      amount === null ||
                      amount === undefined ||
                      amount === "" ||
                      parseInt(amount) === 0 ||
                      isLoading ||
                      payerName === ""
                    }
                    id="pay_now_button"
                  >
                    إدفع الأن
                  </button>
                </div>
                <p className="text d-lg-none d-block fw-bold h6 mt-3 ">
                  أو يمكنك السداد في إحدى البنوك التالية بأستخدام كود الوحدة
                </p>
              </div>
            </div>
          </div>
          <Slider {...settings} className="pay-online__slider mt-3">
            <div>
              <img className="img-fluid" src={ahlyBank} alt="ahly bank" />
            </div>
            <div>
              <img className="img-fluid" src={alexBank} alt="alex bank" />
            </div>
            <div>
              <img className="img-fluid" src={masrBank} alt="masr bank" />
            </div>
            <div>
              <img className="img-fluid" src={carioBank} alt="cario bank" />
            </div>
            <div>
              <img className="img-fluid" src={aubBank} alt="aub bank" />
            </div>
            <div>
              <img className="img-fluid" src={abkBank} alt="abk bank" />
            </div>
            <div>
              <img className="img-fluid" src={egBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={fabMisrBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={faselBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={nbgBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={albarkaBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={arabBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={nibBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={nbdBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={saibBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={ealbBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={egyptPostBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={housingBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={abcBank} alt="egBank" />
            </div>
            <div>
              <img className="img-fluid" src={arabInvesBank} alt="egBank" />
            </div>
          </Slider>
        </div>
      </div>
    </MainContent>
  );
}
export default PayOnline;
